import React from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { FiPackage, FiMail, FiArrowRight } from 'react-icons/fi';
import PrimaryButton from '../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import SecondaryButton from '../../Components/Buttons/SecondaryButton/SecondaryButton.component';
import {
  HeroSection,
  HeroContainer,
  HeroGrid,
  HeroContent,
  HeroTitle,
  HeroDescription,
  HeroActions,
  OrderPanel,
  OrderPanelHeader,
  OrderPanelIcon,
  OrderPanelTitle,
  OrderPanelDescription,
  OrderSteps,
  OrderStep,
  OrderStepNumber,
  OrderStepContent,
  OrderStepTitle,
  OrderStepText,
  OrderPanelFooter,
  OrderContactLink,
} from './ExploreProducts.styles';
const ProductHero = () => {
  const navigate = useNavigate();
  const handleBrowseProducts = () => {
    document
      ?.getElementById('product-catalog')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const handleContact = () => {
    navigate('/contact-us');
  };
  return (
    <HeroSection>
      <Breadcrumbs
        one="Home"
        oneLink="/"
        two="Shop"
        twoLink="/shop"
        three="Products"
      />
      <HeroContainer>
        <HeroGrid>
          <HeroContent>
            {/* <HeroEyebrow>Explore Our Products</HeroEyebrow> */}

            <HeroTitle>Safety Products for Real-World Workplaces</HeroTitle>

            <HeroDescription>
              Explore workplace safety equipment and essential products
              available through our supplier network. Browse common categories,
              compare product options, and contact our team for availability,
              pricing, and ordering support.
            </HeroDescription>

            <HeroActions>
              <PrimaryButton
                functionName={handleBrowseProducts}
                span="Browse Products"
              />
              <SecondaryButton
                functionName={handleContact}
                span="Contact Our Team"
              />
            </HeroActions>
          </HeroContent>

          <OrderPanel>
            <OrderPanelHeader>
              <OrderPanelIcon aria-hidden="true">
                <FiPackage />
              </OrderPanelIcon>

              <div>
                {/* <OrderPanelEyebrow>How to Order</OrderPanelEyebrow> */}

                <OrderPanelTitle>
                  Find It. Ask About It. Order Directly.
                </OrderPanelTitle>
              </div>
            </OrderPanelHeader>

            <OrderPanelDescription>
              Products are not purchased through the website. Our team confirms
              the details of every inquiry before an order is placed.
            </OrderPanelDescription>

            <OrderSteps>
              <OrderStep>
                <OrderStepNumber>01</OrderStepNumber>

                <OrderStepContent>
                  <OrderStepTitle>Explore the catalogue</OrderStepTitle>

                  <OrderStepText>
                    Browse available products, categories, brands, and common
                    workplace applications.
                  </OrderStepText>
                </OrderStepContent>
              </OrderStep>

              <OrderStep>
                <OrderStepNumber>02</OrderStepNumber>

                <OrderStepContent>
                  <OrderStepTitle>Send us an inquiry</OrderStepTitle>

                  <OrderStepText>
                    Tell us which product you need, along with the quantity and
                    any important specifications.
                  </OrderStepText>
                </OrderStepContent>
              </OrderStep>

              <OrderStep>
                <OrderStepNumber>03</OrderStepNumber>

                <OrderStepContent>
                  <OrderStepTitle>
                    Confirm availability and pricing
                  </OrderStepTitle>

                  <OrderStepText>
                    Our team reviews your request and confirms product details,
                    pricing, and next steps.
                  </OrderStepText>
                </OrderStepContent>
              </OrderStep>
            </OrderSteps>

            <OrderPanelFooter>
              <OrderContactLink type="button" onClick={handleContact}>
                <FiMail />
                Contact Us to Order
                <FiArrowRight />
              </OrderContactLink>
            </OrderPanelFooter>
          </OrderPanel>
        </HeroGrid>
      </HeroContainer>
    </HeroSection>
  );
};

export default ProductHero;
